'use strict';
module.exports = require('./ToastService.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/toastservice/index.js
// module id = 468
// module chunks = 7